export default __webpack_public_path__ + "static/media/logo_pneusystem.de5d4120.png";